(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ManageHomeBranch', ManageHomeBranch);

        ManageHomeBranch.$inject = ['$resource'];

    function ManageHomeBranch ($resource) {
        var resourceUrl =  'api/home-branch/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }, 
            'getAllHomeBranchesForBank': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/home-branch-for-bank/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                params: {corpId:'@corpId'},
                url: 'api/home-branch/:corpId',
                transformRequest: function (data) {
                	var copy = angular.copy(data);
                    return angular.toJson(copy);
                }                
            },
            'update': {
            	method:'PUT',
            	params: {corpId:'@corpId'},
                url: 'api/home-branch/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'delete':{
                method: 'DELETE',
                params: {corpId:'@corpId', id:'@id'},
                url: 'api/home-branch/:corpId/:id'    
                },
         
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForCreate/home-branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'resubmitForEdit': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForEdit/home-branch',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'exportHomeBranchExcel':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/home-branch/export/excel',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportHomeBranchCsv':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/home-branch/export/csv',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
            'exportHomeBranchDetails': {
                method: 'POST',
                url: 'api/home-branch/export/homeBranchExcel',
                 transformResponse: function (data) {
                 return data;
                }
            },
        });
    }
})();